/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissuesalesend3Inputs */

const en_ticketsissuesalesend3 = /** @type {(inputs: Ticketsissuesalesend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid date.`)
};

const de_ticketsissuesalesend3 = /** @type {(inputs: Ticketsissuesalesend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib ein gültiges Datum ein.`)
};

/**
* | output |
* | --- |
* | "Please enter a valid date." |
*
* @param {Ticketsissuesalesend3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissuesalesend3 = /** @type {((inputs?: Ticketsissuesalesend3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissuesalesend3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissuesalesend3(inputs)
	return de_ticketsissuesalesend3(inputs)
});
export { ticketsissuesalesend3 as "ticketsIssueSalesEnd" }